var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},_vm._l((_vm.projects),function(project,idx){return _c('div',{key:idx},[_c('Project',{attrs:{"title":project.title,"miniTitle":project.miniTitle,"description":project.description,"imgSrc":project.imgSrc,"techs":project.techs,"links":project.links}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }